// Wat een Verplaatsingsbevestiging betekent, los van hoe hij eruitziet (ADR-0074).
//
// De bevestiging draagt drie rollen: `old_*` is het moment waarop de deelnemer
// boekte en wordt na de eerste verplaatsing nooit meer overschreven, `previous_*`
// is de tussenstop, en het huidige moment staat op het tijdslot zelf. De popup
// zet het oorspronkelijke tegenover het huidige; de tussenstop staat alleen in de
// mail, want die verklaart enkel waarom er een tweede mail ligt.
//
// Bewust zonder imports en zonder datumopmaak: de scripts/*.mjs-tests draaien dit
// bestand in een `vm` die alleen `export` wegstript, dus een import zou de test
// breken. De weergave — Amsterdamse kalenderdatum, tijdvak, labels — hoort in de
// component.

/**
 * Een bevestiging die meer dan één verplaatsing omvat. Een legacy-rij draagt
 * geen `moves` en telt daarmee als de eerste verplaatsing.
 */
export function isMovedAgain(confirmationData) {
  return Number((confirmationData || {}).moves || 1) >= 2;
}

/**
 * Of de ruimte een kolom verdient. Alleen als hij daadwerkelijk meeverhuisde: een
 * zaal die gelijk blijft zegt niets over deze verplaatsing, en twee lege zalen
 * zeggen al helemaal niets.
 */
export function showsRoom(confirmationData, currentRoom) {
  const from = (confirmationData || {}).old_room || "";
  const to = currentRoom || "";

  return from !== to && (from !== "" || to !== "");
}

/**
 * De twee rijen van de Van/Naar-tabel, met ruwe waarden.
 *
 * Zonder `old_date` — een bevestiging waarvan de data leeg is — valt "Van" terug
 * op het huidige moment, zodat de tabel geen lege regel toont.
 *
 * @param {object} confirmationData `activity_slot_enroll_confirmations.data`
 * @param {{date:*, start:string, end:string, room:string}} current het tijdslot nu
 */
export function relocationMoments(confirmationData, current) {
  const data = confirmationData || {};
  const now = current || {};
  const hasOld = data.old_date !== undefined && data.old_date !== null;

  return [
    {
      key: "from",
      old: true,
      date: hasOld ? data.old_date : now.date,
      start: hasOld ? data.old_start : now.start,
      end: hasOld ? data.old_end : now.end,
      room: data.old_room || "",
    },
    {
      key: "to",
      old: false,
      date: now.date,
      start: now.start,
      end: now.end,
      room: now.room || "",
    },
  ];
}
